import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
//import ReactGa from 'react-ga';
import LoadingOverlay from '../components/features/loading-overlay';
import { scrollTop } from '../utils';
import ReactPixel from 'react-facebook-pixel';

const AdminRoute = React.lazy( () => import('./admin-route.js') ) ;
const OrganizerRoute = React.lazy( () => import('./organizer-route.js') ) ;
const EventsRoute = React.lazy( () => import( './event-route.js' ) );
const ShopPages = React.lazy( () => import( './shop-route.js' ) );
const OtherPages = React.lazy( () => import( './others-route.js' ) );
const HomePage = React.lazy( () => import( './home-route.js' ) );
const AuthPages = React.lazy( () => import( './auth-route.js' ) );
const PromoterPage = React.lazy( () => import( './promoter-route.js' ) );


export default function AppRoot() {

    const history = useHistory();

    const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
      };
      
      useEffect( () => {
        scrollTop();

        const pixelMeta = document.createElement('meta');
        pixelMeta.setAttribute('name','facebook-domain-verification');
        pixelMeta.setAttribute('content', 'ovjx0ckcmvpsfrh9fbemjagb7ffdxo');
        document.head.insertAdjacentElement('beforeend', pixelMeta);
          
        ReactPixel.init(`${process.env.REACT_APP_PIXEL_CODE}`, {}, options);
        ReactPixel.trackSingle(`${process.env.REACT_APP_PIXEL_CODE}`, "PageView");

        history.listen( location => {
            ReactPixel.trackSingle(`${process.env.REACT_APP_PIXEL_CODE}`, "PageView");
        });

    }, [] );

    return (
        <React.Suspense fallback={ <LoadingOverlay /> }>
            <Switch>
                <Route path={ `${process.env.PUBLIC_URL}/e` } component={ EventsRoute } />
                <Route path={ `${process.env.PUBLIC_URL}/event` } component={ EventsRoute } />
                <Route path={ `${process.env.PUBLIC_URL}/events` } component={ ShopPages } />

                <Route path={ `${process.env.PUBLIC_URL}/shop` } component={ ShopPages } />
                <Route path={ `${process.env.PUBLIC_URL}/pages` } component={ OtherPages } />
                <Route path={ `${process.env.PUBLIC_URL}/login` } component={ AuthPages } />

                <Route path={ `${process.env.PUBLIC_URL}/admin` } component={ AdminRoute } />
                <Route path={ `${process.env.PUBLIC_URL}/organizer` } component={ OrganizerRoute } />
                <Route path={ `${process.env.PUBLIC_URL}/promoter` } component={ PromoterPage } />

                <Route exact path={ `${process.env.PUBLIC_URL}/` } component={ HomePage } />
            </Switch>
        </React.Suspense>
    )
}
